import { render, staticRenderFns } from "./ExcelUrunFiyatGuncelle.vue?vue&type=template&id=31878465"
import script from "./ExcelUrunFiyatGuncelle.vue?vue&type=script&lang=js"
export * from "./ExcelUrunFiyatGuncelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports